// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1qsnD","label":"Category_label__2R_Tm","content":"Category_content__2tBlP","header":"Category_header__2aQE1","location":"Category_location__3pJCG"};